import React, { useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";
import OrgStructureForm from "./OrgStructureForm";
import OrgStructureList from "./OrgStructureList";

const OrgStructureManager = () => {
  const [show, setShow] = useState(false);
  const [action, setAction] = useState("");
  const [row, setRow] = useState(null);

  const onAction = (type, data) => {
    setAction(type);
    setRow(data);
    setShow(true);
  };

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between mb-3">
        <h4>Organizational Structure</h4>
        <button className="btn btn-primary"
          onClick={() => onAction("add", null)}>
          + Add
        </button>
      </div>

      <OrgStructureList onAction={onAction} />

      {show && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title text-capitalize">
                    {action} Record
                  </h5>
                  <button className="btn-close" onClick={() => setShow(false)} />
                </div>

                <div className="modal-body">
                  {action === "add" && (
                    <OrgStructureForm
                      onSuccess={() => setShow(false)}
                    />
                  )}

                  {action === "edit" && (
                    <OrgStructureForm
                      editData={row}
                      onSuccess={() => setShow(false)}
                    />
                  )}

                  {action === "view" && (
                    <pre>{JSON.stringify(row, null, 2)}</pre>
                  )}

                  {action === "delete" && (
                    <>
                      <p>Delete this record?</p>
                      <button className="btn btn-danger"
                        onClick={async () => {
                          await axios.delete(
                            `${REACT_APP_API_URL}api/dashboard/admin/org-structure/${row.OrgID}`
                          );
                          setShow(false);
                        }}>
                        Confirm Delete
                      </button>
                    </>
                  )}
                </div>

              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default OrgStructureManager;
